import React, { useEffect, useState } from 'react';

import { useTranslation } from '~/shared/utils/translation';
import {
    StyledDrawerContainer,
    StyledDrawerContent,
    StyledCloseButton,
    StyleAccordionContent,
    StyledResponsiveActionButtons,
} from './styled';
import CloseIcon from '$icons/close.svg';
import { StyledDrawerHeader, StyledDrawerOverlay } from '../../SortBy/styled';
import { VisuallyHidden } from '~/shared/components/VisuallyHidden';
import { ClearFiltersButton } from './components/ClearFiltersButton';
import { connectStateResults, StateResultsProvided } from 'react-instantsearch-core';
import { useHeaderHeight, useScrollLock } from '~/shared/hooks';
import { AccordionGroups } from './components/AccordionGroups';
import { Button } from '~/shared/components';

type FilterDrawerProps = {
    isOpen: boolean;
    onClose?: () => void;
} & StateResultsProvided;

const lockId = 'filtersDrawer';

const CustomFiltersDrawer = React.memo(({ isOpen, onClose, searchResults }: FilterDrawerProps) => {
    const { translate } = useTranslation();
    const { lock, unlock } = useScrollLock();
    const headerHeight = useHeaderHeight(isOpen);
    const [isVisible, setIsVisible] = useState<boolean>(isOpen);

    useEffect(() => {
        isOpen ? lock(lockId) : unlock(lockId);
        return () => unlock(lockId);
    }, [isOpen, lock, unlock]);

    return (
        <StyledDrawerContainer>
            <StyledDrawerOverlay isOpen={isOpen} onClick={onClose} />
            <StyledDrawerContent
                isOpen={isOpen}
                top={headerHeight}
                onAnimationEnd={() => setIsVisible(isOpen)}
                style={{ display: isOpen || isVisible ? '' : 'none' }}
            >
                <StyledDrawerHeader>
                    {translate('commerce.filters.filterBy')}
                    <StyledCloseButton shape={'icon'} onClick={onClose}>
                        <VisuallyHidden children={translate('general.close')} />
                        <CloseIcon aria-hidden="true" />
                    </StyledCloseButton>
                </StyledDrawerHeader>
                <StyleAccordionContent top={headerHeight}>
                    <AccordionGroups maxValuesPerFacet={100} />
                    <StyledResponsiveActionButtons>
                        <ClearFiltersButton />
                        <Button variant="primary" onClick={onClose} size="md">
                            {translate('commerce.viewFilteredResults')} ({searchResults?.nbHits})
                        </Button>
                    </StyledResponsiveActionButtons>
                </StyleAccordionContent>
            </StyledDrawerContent>
        </StyledDrawerContainer>
    );
});

export const FiltersDrawer = connectStateResults<FilterDrawerProps>(CustomFiltersDrawer);
